import type { FreeRoomsResponse, PublicCalendarTokenDto } from '@hub-wifi/shared'
import { apiRequest } from './client'

/**
 * Read the current public-calendar subscribe URL for a room WITHOUT
 * rotating the token. Used by RoomFormPage to populate the URL on mount
 * when the room already has a token, so admins don't have to regenerate
 * (breaking active subscribers) just to retrieve the URL.
 */
export function getPublicCalendarSubscribeInfo(
  buildingId: string,
  roomId: string,
  token: string,
): Promise<PublicCalendarTokenDto> {
  return apiRequest<PublicCalendarTokenDto>(
    `/api/buildings/${buildingId}/rooms/${roomId}/public-token`,
    { token },
  )
}

export function generatePublicCalendarToken(
  buildingId: string,
  roomId: string,
  token: string,
): Promise<PublicCalendarTokenDto> {
  return apiRequest<PublicCalendarTokenDto>(
    `/api/buildings/${buildingId}/rooms/${roomId}/public-token`,
    { method: 'POST', token },
  )
}

export function revokePublicCalendarToken(
  buildingId: string,
  roomId: string,
  token: string,
): Promise<{ ok: true }> {
  return apiRequest<{ ok: true }>(`/api/buildings/${buildingId}/rooms/${roomId}/public-token`, {
    method: 'DELETE',
    token,
  })
}

/**
 * The caller's bookable rooms with whether [from, from+minutes) is free and
 * `freeUntil` (capped at building closing). One request for every room.
 */
export function listFreeRooms(
  from: string,
  minutes: number,
  token: string,
): Promise<FreeRoomsResponse> {
  const qs = new URLSearchParams({ from, minutes: String(minutes) })
  return apiRequest<FreeRoomsResponse>(`/api/my/rooms/free?${qs}`, { token })
}
